import json from "./defaultConfigJson.json";

export const smartdelivery = json;

export default smartdelivery;
